import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { Mood } from "@teammood/timeline";
import { TranslateModule } from "@ngx-translate/core";
import { NgClass } from "@angular/common";
import { TmMoodPickersComponent } from "../../../../shared/ui/moodpickers/mood-pickers.component";
import { FormControl, FormsModule, ReactiveFormsModule } from "@angular/forms";

@Component({
    selector: "tm-edit-mood-box",
    templateUrl: "./edit-mood-box.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TranslateModule,
        NgClass,
        TmMoodPickersComponent,
        FormsModule,
        ReactiveFormsModule
    ]
})
export class EditMoodBoxComponent implements OnInit {

    @Input({required: true})
    mood: Mood;

    @Output()
    onEdit: EventEmitter<Mood> = new EventEmitter();

    @Output()
    onCancel: EventEmitter<void> = new EventEmitter();

    protected moodCommentCtrl = new FormControl<string>('');

    ngOnInit() {
        this.moodCommentCtrl.setValue(this.mood.comment?.body);
    }

    protected cancelUpdate() {
        this.onCancel.emit();
    }

    protected saveUpdate() {
        this.mood.comment = {
            body: this.moodCommentCtrl.getRawValue(),
            linkPreviews: []
        };
        this.onEdit.emit(this.mood);
    }

    protected fromMoodPicker(element: string) {
        if (this.moodCommentCtrl.getRawValue()?.length > 0) {
            this.moodCommentCtrl.setValue(this.moodCommentCtrl.getRawValue() + ' ' + element);
        } else {
            this.moodCommentCtrl.setValue(element);
        }
    }
}